import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { MetaPixelTracker } from "./components/MetaPixelTracker";
import { CookieConsent } from "./components/CookieConsent";
import Home from "./pages/Home";
import AdminLogin from "./pages/AdminLogin";

import AdminDashboard from "./pages/AdminDashboard";
import LocalPage from "./pages/LocalPage";
import Landing from "./pages/Landing";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <MotionConfig reducedMotion="user">
      <AuthProvider>
        <BrowserRouter>
          <MetaPixelTracker />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/fotografia-case-vacanze" element={<Landing />} />
            <Route path="/:slug" element={<LocalPage />} />
          </Routes>
        </BrowserRouter>
        <CookieConsent />
        <Toaster theme="dark" position="bottom-right" />
      </AuthProvider>
    </MotionConfig>
  );
}

export default App;
